/* tslint:disable */
/* eslint-disable */
export enum AutoSubmitPrebidType {
  Ask = 'ask',
  Enabled = 'enabled',
  Disabled = 'disabled'
}
